import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
  ReactNode,
} from "react";
import {
  connectWebSocket,
  disconnectWebSocket,
  sendEventMessage,
} from "../utility/LiveStreamSocket/LiveStreamWebSocketUtils";
import {
  CommentMessage,
  EventMessage,
  GiftMessage,
  LoginData,
} from "../utility/LiveStreamSocket/LiveStreamTypeDefinations";
import {
  fetchStreamDetailsYoutube,
  fetchStreamOrganizerChats,
  fetchStreamOrganizerDetails,
  fetchStreamOrganizerGifts,
  fetchStreamOrganizerLikes,
  fetchStreamParticipantChats,
  fetchStreamParticipantDetails,
  fetchStreamParticipantGifts,
  fetchStreamParticipantLikes,
  fetchUserDetails,
  fetchLiveViewers,
} from "../services/stream";
import BuyTicketModal from "../screens/Auth/WebScreens/Modals/BuyTicketModal";
import SignUpModal from "../screens/Auth/WebScreens/Modals/SignUpModal";
import LiveStreamSignUpModal from "../Components/live-streaming-common-components/LiveStreamSignUpModal";
import SuccessFullSignUpModal from "../screens/Auth/WebScreens/Modals/SuccessFullSignUpModal";
import PurchaseSuccessModal from "../screens/Auth/WebScreens/Modals/PurchaseSuccessModal";
import LiveStreamBuyTicketModal from "../Components/live-streaming-common-components/LiveStreamBuyTicketModal";
import { fetchEventDetails, updateEvent } from "../services/eventsAPI";
import {
  STREAM_ROLES,
  STREAM_STATUS,
  EVENT_STATUS,
} from "../utility/LiveStreamSocket/LiveStreamConfig";
import { useNavigation, useNavigationState } from "@react-navigation/native";

interface LiveStreamContextProps {
  gifts: GiftMessage[];
  comments: CommentMessage[];
  organizerData: {
    chats: any[];
    gifts: any[];
    likes: number;
    eventDetails: any;
    streamDetails: any;
    disputeDetails: any;
    winnerDetails?: any;
    participantDetails?: any;
  };
  audienceData: {
    chats: any[];
    gifts: any[];
    likes: number;
    eventDetails: any;
    streamDetails: any;
    participantDetails: any[];
    disputeDetails: any;
    winnerDetails?: any;
  };
  totalViewers: number;
  liveStreamId: string | null;
  totalGiftedTokens: number;
  setTotalGiftedTokens: React.Dispatch<React.SetStateAction<number>>;
  setAudienceData: React.Dispatch<
    React.SetStateAction<{
      chats: any[];
      gifts: any[];
      likes: number;
      eventDetails: any;
      streamDetails: any;
      participantDetails: Array<{
        userId: string;
        role: string;
        profilePicture: string;
      }>;
      winnerDetails?: any;
    }>
  >;
  setOrganizerData: React.Dispatch<
    React.SetStateAction<{
      chats: any[];
      gifts: any[];
      likes: number;
      eventDetails: any;
      streamDetails: any;
      disputeDetails: any;
      winnerDetails?: any;
    }>
  >;
  connectToEvent: (
    userId: string,
    eventId: string,
    accessToken: string,
    userRole: string
  ) => void;
  disconnectFromEvent: () => void;
  sendGift: (giftContent: any, receiverId: string) => void;
  sendComment: (
    userId: string,
    eventId: string,
    commentContent: any,
    commentType: string
  ) => void;
  sendLike: () => void;
  alreadyLiked: boolean;
  loginData: any;
  viewerDetails: any;
  setUserData: React.Dispatch<React.SetStateAction<any>>;
  userData: any;
  currentEventId: string | null;
  closePurchaseSuccessModal: () => void;
  closeBuyTicketModal: (success: boolean) => void;
  eventDate: any;
  setEventDate: React.Dispatch<React.SetStateAction<any>>;
  setLiveStreamId: any;
  updateEventTime: any;
  organiserLiveStart: boolean;
  organiserStreamCompleted: boolean;
  challengerLiveStart: boolean;
  challengerStreamCompleted: boolean;
  organiserStreamStatus: string;
  challengerStreamStatus: string;
  setOrganiserStreamStatus: React.Dispatch<React.SetStateAction<string>>;
  setChallengerStreamStatus: React.Dispatch<React.SetStateAction<string>>;
  setOrganiserLiveStart: React.Dispatch<React.SetStateAction<boolean>>;
  setChallengerLiveStart: React.Dispatch<React.SetStateAction<boolean>>;
  setOrganiserStreamCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  setChallengerStreamCompleted: React.Dispatch<React.SetStateAction<boolean>>;
  loader: boolean;
  setLoader: React.Dispatch<React.SetStateAction<boolean>>;
  isTwitchStreamingEnabled: boolean;
  setIsTwitchStreamingEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  eventStartTime: any;
  streamStatus: any;
  userRole: string;
  eventStatus: any;
  eventEndTime: any;
  setEventEndTime: any;
  organiserStreamStartTime: any;
  challengerStreamStartTime: any;
  setOrganiserStreamStartTime: any;
  setChallengerStreamStartTime: any;
  setEventStatus: any;
  organiserStreamPaused: boolean;
  challengerStreamPaused: boolean;
  setOrganiserStreamPaused: React.Dispatch<React.SetStateAction<boolean>>;
  setChallengerStreamPaused: React.Dispatch<React.SetStateAction<boolean>>;
}

interface LiveStreamProviderProps {
  children: ReactNode;
}

export const LiveStreamContext = createContext<
  LiveStreamContextProps | undefined
>(undefined);

export const LiveStreamProvider: React.FC<LiveStreamProviderProps> = ({
  children,
}) => {
  const [gifts, setGifts] = useState<GiftMessage[]>([]);
  const [comments, setComments] = useState<CommentMessage[]>([]);
  const [loginData, setLoginData] = useState<LoginData | null>(null);
  const [currentEventId, setCurrentEventId] = useState<string | null>(null);
  const [loader, setLoader] = useState(false);
  const [organizerData, setOrganizerData] = useState({
    chats: [],
    gifts: [],
    likes: 0,
    eventDetails: {},
    streamDetails: {},
    disputeDetails: {},
    winnerDetails: {},
  });
  const [audienceData, setAudienceData] = useState({
    chats: [],
    gifts: [],
    likes: 0,
    eventDetails: {},
    streamDetails: {},
    participantDetails: [],
    disputeDetails: {},
    winnerDetails: {},
  });
  const [totalViewers, setTotalViewers] = useState(0);
  const [liveStreamId, setLiveStreamId] = useState<string | null>(null);
  const [totalGiftedTokens, setTotalGiftedTokens] = useState(0);
  const [viewerDetails, setViewerDetails] = useState<any[]>([]);
  const [userData, setUserData] = useState(null);
  const [alreadyLiked, setAlreadyLiked] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showBuyTicketModal, setShowBuyTicketModal] = useState(false);
  const [showPurchaseSuccessModal, setShowPurchaseSuccessModal] =
    useState(false);
  const [eventDate, setEventDate] = useState(null);
  const [eventStartTime, setEventStartTime] = useState(null);
  const [eventEndTime, setEventEndTime] = useState(null);
  const [streamStatus, setStreamStatus] = useState(null);
  const [userRole, setUserRole] = useState("audience");
  const [organiserStreamPaused, setOrganiserStreamPaused] = useState(false);
  const [challengerStreamPaused, setChallengerStreamPaused] = useState(false);
  const [organiserStreamStatus, setOrganiserStreamStatus] = useState("created");
  const [challengerStreamStatus, setChallengerStreamStatus] =
    useState("created");
  const [organiserLiveStart, setOrganiserLiveStart] = useState(false);
  const [challengerLiveStart, setChallengerLiveStart] = useState(false);

  const [organiserStreamCompleted, setOrganiserStreamCompleted] =
    useState(false);
  const [challengerStreamCompleted, setChallengerStreamCompleted] =
    useState(false);
  const [isTwitchStreamingEnabled, setIsTwitchStreamingEnabled] =
    useState(false);

  const [organiserStreamStartTime, setOrganiserStreamStartTime] =
    useState(null);
  const [challengerStreamStartTime, setChallengerStreamStartTime] =
    useState(null);

  const [eventStatus, setEventStatus] = useState(null);
  const navigation = useNavigation();

  const updateEventTime = async (
    field: "eventStartTime" | "eventEndTime" | "",
    accessToken: string,
    eventId: string,
    organiserStreamStatus?: "created" | "live" | "complete" | "",
    challengerStreamStatus?: "created" | "live" | "complete" | ""
  ) => {
    try {
      const updateBody: any = {
        accessToken,
        eventID: eventId,
        type: "stream",
        newDetails: {},
      };

      if (field) {
        updateBody.newDetails[field] = new Date().toISOString();
      }

      if (organiserStreamStatus) {
        updateBody.newDetails.organiserStreamStatus = organiserStreamStatus;

        if (organiserStreamStatus === "live") {
          updateBody.newDetails.status = "ongoing";
        } else if (organiserStreamStatus === "complete") {
          updateBody.newDetails.status = "complete";

          if (challengerStreamStatus) {
            updateBody.newDetails.challengerStreamStatus =
              challengerStreamStatus;
          }
        }
      }

      if (challengerStreamStatus && !organiserStreamStatus) {
        updateBody.newDetails.challengerStreamStatus = challengerStreamStatus;
      }

      await updateEvent(updateBody);
    } catch (error) {
      console.error(`Error updating ${field} and stream status:`, error);
    }
  };

  const handleEventMessage = (message: EventMessage) => {
    if (message.type === "gift") {
      const giftData = message.data;

      setOrganizerData((prev) => ({
        ...prev,
        gifts: [...prev.gifts, giftData],
      }));
      setAudienceData((prev) => ({
        ...prev,
        gifts: [...prev.gifts, giftData],
      }));

      setTotalGiftedTokens((prev) => prev + (giftData?.giftValue || 0));
    } else if (message.type === "comment") {
      setOrganizerData((prev) => ({
        ...prev,
        chats: [...prev.chats, message],
      }));
      setAudienceData((prev) => ({
        ...prev,
        chats: [...prev.chats, message],
      }));
    } else if (message.type === "joined") {
      // Viewer count is now handled by polling API - no action needed here
    } else if (message.type === "left") {
      // Viewer count is now handled by polling API - no action needed here
    } else if (message.type === "like") {
      setOrganizerData((prev) => ({
        ...prev,
        likes: prev.likes + 1,
      }));

      setAudienceData((prev) => ({
        ...prev,
        likes: prev.likes + 1,
      }));
    } else if (
      message.type === "stream_live" ||
      message.type === "stream_completed" ||
      message.type === "challenger_stream_live" ||
      message.type === "challenger_stream_completed"
    ) {
      // Determine role from message type
      const role = message.type.includes("challenger")
        ? "challenger"
        : "organiser";
      const newStatus = message.type.includes("completed")
        ? "completed"
        : "live";

      console.log("=== STREAM EVENT RECEIVED ===");
      console.log("Type:", message.type);
      console.log("Role:", role);
      console.log("New Status:", newStatus);
      console.log("Event ID:", message.eventId);

      // Update organizer data - preserve existing stream statuses, only update the role that changed
      setOrganizerData((prev: any) => {
        const currentStreamStatus = prev.eventDetails?.streamStatus || {};
        const newStreamStatus = {
          ...currentStreamStatus,
          [role]: newStatus,
        };

        // If organiser completed, set both to completed
        if (role === "organiser" && newStatus === "completed") {
          newStreamStatus.organiser = "completed";
          newStreamStatus.challenger = "completed";
        }

        return {
          ...prev,
          eventDetails: {
            ...prev.eventDetails,
            status: message.eventStatus || prev.eventDetails?.status,
            streamStatus: newStreamStatus,
            eventEndTime:
              message.eventEndTime || prev.eventDetails?.eventEndTime,
          },
          // Keep existing streamDetails - already populated from initial load
        };
      });

      setAudienceData((prev: any) => {
        const currentStreamStatus = prev.eventDetails?.streamStatus || {};
        const newStreamStatus = {
          ...currentStreamStatus,
          [role]: newStatus,
        };

        if (role === "organiser" && newStatus === "completed") {
          newStreamStatus.organiser = "completed";
          newStreamStatus.challenger = "completed";
        }

        return {
          ...prev,
          eventDetails: {
            ...prev.eventDetails,
            status: message.eventStatus || prev.eventDetails?.status,
            streamStatus: newStreamStatus,
          },
        };
      });

      setEventStatus(message.eventStatus || newStatus);

      // NO BACKGROUND REFETCH - streamDetails already loaded from initial page load
    } else if (message.type === "public_voting_enabled") {
      const newPollEndTime = message.pollEndTime;

      setOrganizerData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          pollEndTime: newPollEndTime,
          publicVotingEnabled: true,
        },
      }));

      setAudienceData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          pollEndTime: newPollEndTime,
          publicVotingEnabled: true,
        },
      }));
    } else if (message.type === "public_voting_count") {
      const newVotes = message.votes;

      setOrganizerData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          hasVoted: true,
          publicVoteStats: newVotes,
        },
      }));

      setAudienceData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          hasVoted: true,
          publicVoteStats: newVotes,
        },
      }));
    } else if (message.type === "success") {
      const winnerDetails = message.winnerDetails;

      setOrganizerData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          resultStatus: {
            resultSubmitted: true,
            dispute: false,
            winner: winnerDetails?.username,
            publicVotingEnabled: false,
          },
        },
        winnerDetails,
      }));

      setAudienceData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          resultStatus: {
            resultSubmitted: true,
            dispute: false,
            winner: winnerDetails?.username,
            publicVotingEnabled: false,
          },
        },
        winnerDetails,
      }));
    } else if (message.type === "dispute") {
      const disputeEndTimes = message.disputeEndTime;
      setOrganizerData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          resultStatus: {
            dispute: true,
          },
          disputeEndTime: disputeEndTimes,
        },
      }));

      setAudienceData((prev) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          resultStatus: {
            dispute: true,
          },
          disputeEndTime: disputeEndTimes,
        },
      }));
    } else if (message.type === "stream_paused") {
      const { role, streamLive } = message;
      if (role === "organiser") {
        setOrganiserStreamPaused(!streamLive);
      } else if (role === "challenger") {
        setChallengerStreamPaused(!streamLive);
      }
      setOrganizerData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          streamStatus: {
            ...prev.eventDetails.streamStatus,
            [role]: streamLive ? "live" : "paused",
          },
        },
      }));
      setAudienceData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          streamStatus: {
            ...prev.eventDetails.streamStatus,
            [role]: streamLive ? "live" : "paused",
          },
        },
      }));
    } else if (message.type === "stream_live_again") {
      const { role } = message;

      if (role === "organiser") {
        setOrganiserStreamPaused(false);
      } else if (role === "challenger") {
        setChallengerStreamPaused(false);
      }

      setOrganizerData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          streamStatus: {
            ...prev.eventDetails.streamStatus,
            [role]: "live",
          },
        },
      }));

      setAudienceData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          streamStatus: {
            ...prev.eventDetails.streamStatus,
            [role]: "live",
          },
        },
      }));
    }
  };

  const fetchDetailsAndLikes = async (
    eventId: string,
    accessToken: string,
    fetchDetailsFn: any,
    fetchLikesFn: any,
    setDataFn: any
  ) => {
    try {
      const [detailsResponse, likesResponse, viewersResponse] =
        await Promise.all([
          fetchDetailsFn(eventId, accessToken),
          fetchLikesFn(eventId, accessToken),
          fetchLiveViewers(eventId, accessToken),
        ]);

      // Get viewer data from the dedicated live viewers API (response is direct, not wrapped)
      const allViewers = viewersResponse?.viewerDetails || [];

      console.log("=== DEBUG: fetchLiveViewers response ===");
      console.log("viewersResponse:", viewersResponse);
      console.log("allViewers:", allViewers);

      // Filter to only show audience members (exclude organizer and challenger)
      const filteredViewers = allViewers.filter(
        (viewer: any) => viewer.role === "audience"
      );

      console.log("filteredViewers:", filteredViewers);
      console.log("filteredViewers.length:", filteredViewers.length);

      const message = detailsResponse.body.message?.toLowerCase();
      const streamDetails = detailsResponse.body.streamDetails;
      const disputeDetails = detailsResponse.body.disputeDetails;
      if (
        message?.includes("sign up") ||
        message?.includes("purchase a ticket")
      ) {
        const { eventDetails, participantDetails, winnerDetails } =
          detailsResponse.body;
        setDataFn((prev) => ({
          ...prev,
          eventDetails,
          participantDetails: participantDetails || [],
          winnerDetails: winnerDetails || {},
        }));
        if (message.includes("sign up")) {
          setShowSignUpModal(true);
        } else if (message.includes("purchase a ticket")) {
          setShowBuyTicketModal(true);
        }
        return;
      }

      setEventStartTime(
        detailsResponse.body.eventDetails.eventStartTime || null
      );

      setOrganiserStreamStartTime(
        detailsResponse.body.eventDetails.organiserStreamStartTime || null
      );
      setChallengerStreamStartTime(
        detailsResponse.body.eventDetails.challengerStreamStartTime || null
      );
      setEventStatus(detailsResponse.body.eventDetails.status);

      if (
        detailsResponse.body.eventDetails.status === STREAM_STATUS.COMPLETED
      ) {
        setEventEndTime(detailsResponse.body.eventDetails.eventEndTime || null);
      }

      setStreamStatus(detailsResponse.body.eventDetails.streamStatus || null);

      setDataFn((prev) => ({
        ...prev,
        eventDetails: detailsResponse.body.eventDetails,
        streamDetails: streamDetails,
        likes: likesResponse.body.likeCount,
        disputeDetails: disputeDetails,
        winnerDetails: detailsResponse.body.winnerDetails || {},
      }));

      if (detailsResponse.body.eventDetails?.liveStreamWithTwitch) {
        setIsTwitchStreamingEnabled(true);
      }

      // Use viewer data from fetchLiveViewers API
      console.log("=== DEBUG: Setting totalViewers ===");
      console.log("Setting setTotalViewers to:", filteredViewers.length);
      setTotalViewers(filteredViewers.length);
      setViewerDetails(filteredViewers);
      setAlreadyLiked(likesResponse.body.alreadyLiked);
    } catch (error) {
      console.error("Error fetching details and likes:", error);
    }
  };

  const fetchOrganizerData = async (eventId: string, accessToken: string) => {
    setLoader(true);
    try {
      await fetchDetailsAndLikes(
        eventId,
        accessToken,
        fetchStreamOrganizerDetails,
        fetchStreamOrganizerLikes,
        setOrganizerData
      );
      const chats = await fetchStreamOrganizerChats(eventId, accessToken);
      const giftsResponse = await fetchStreamOrganizerGifts(
        eventId,
        accessToken
      );
      const response = (
        await fetchStreamParticipantDetails(eventId, accessToken)
      ).body;

      setOrganizerData((prev) => ({
        ...prev,
        chats: chats.body.data,
        gifts: giftsResponse.body.gifts,
        participantDetails: response.participantDetails || [],
        winnerDetails: response.winnerDetails || {},
      }));

      setTotalGiftedTokens(giftsResponse.body.totalTokens || 0);
    } catch (error) {
      console.error("Error fetching organizer data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchAudienceData = async (eventId: string, accessToken: string) => {
    setLoader(true);
    try {
      await fetchDetailsAndLikes(
        eventId,
        accessToken,
        fetchStreamParticipantDetails,
        fetchStreamParticipantLikes,
        setAudienceData
      );
      const chats = await fetchStreamParticipantChats(eventId, accessToken);
      const giftsResponse = await fetchStreamParticipantGifts(
        eventId,
        accessToken
      );
      const response = (
        await fetchStreamParticipantDetails(eventId, accessToken)
      ).body;
      setAudienceData((prev) => ({
        ...prev,
        chats: chats.body.data,
        gifts: giftsResponse.body.gifts,
        participantDetails: response.participantDetails || [],
        winnerDetails: response.winnerDetails || {},
      }));

      setTotalGiftedTokens(giftsResponse.body.totalTokens || 0);
    } catch (error) {
      console.error("Error fetching audience data:", error);
    } finally {
      setLoader(false);
    }
  };

  const fetchAndReconnectUser = async () => {
    if (!userData?.userID || !currentEventId || !loginData?.accessToken) {
      console.error("Missing required data for reconnection");
      return;
    }

    try {
      const userDetailsResponse = await fetchUserDetails(loginData.accessToken);
      const userDetails = userDetailsResponse.body;

      setUserData({
        userID: userDetails.userID,
        profilePicture:
          userDetails.profilePicture ||
          "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/profile.svg",
        tokens: userDetails.tokens || 0,
        coins: userDetails.coins || 0,
        balance: userDetails.balance || 0,
        credits: userDetails.credits || 0,
      });

      if (loginData.username === "organizer") {
        await fetchOrganizerData(currentEventId, loginData.accessToken);
      } else {
        await fetchAudienceData(currentEventId, loginData.accessToken);
      }

      connectWebSocket(
        userData.userID,
        currentEventId,
        loginData.accessToken,
        STREAM_ROLES.AUDIENCE,
        handleEventMessage
      );
    } catch (error) {
      console.error("Error during re-fetch and reconnect:", error);
    }
  };

  useEffect(() => {
    if (showSuccessModal || showPurchaseSuccessModal) {
      fetchAndReconnectUser();
    }
  }, [showSuccessModal, showPurchaseSuccessModal]);

  const connectToEvent = async (
    userId: string,
    eventId: string,
    accessToken: string,
    userRole: string
  ) => {
    console.log("=== LiveStream connectToEvent START ===", {
      userId,
      eventId,
      userRole,
      hasAccessToken: !!accessToken,
    });

    if (!eventId || !userRole) {
      console.error("Cannot connect without event ID or user role.");
      return;
    }

    setCurrentEventId(eventId);
    setLoginData({ username: userId, accessToken });
    console.log("Set loginData:", {
      username: userId,
      hasAccessToken: !!accessToken,
    });

    try {
      const userDetailsResponse = await fetchUserDetails(accessToken);
      const userDetails = userDetailsResponse.body;

      setUserData({
        userID: userDetails.userID,
        username: userId,
        profilePicture:
          userDetails.profilePicture ||
          "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/profile.svg",
        tokens: userDetails.tokens || 0,
        coins: userDetails.coins || 0,
        balance: userDetails.balance || 0,
        credits: userDetails.credits || 0,
      });
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
    setUserRole(userRole);
    if (
      userRole === STREAM_ROLES.ORGANISER ||
      userRole === STREAM_ROLES.CHALLENGER
    ) {
      await fetchOrganizerData(eventId, accessToken);
    } else if (userRole === STREAM_ROLES.AUDIENCE) {
      await fetchAudienceData(eventId, accessToken);
    }

    connectWebSocket(
      userId,
      eventId,
      accessToken,
      userRole,
      handleEventMessage
    );
  };

  const disconnectFromEvent = () => {
    disconnectWebSocket();
    setCurrentEventId(null);
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    setShowSignUpModal(false);
  };

  const closeSignUpModal = (success: boolean) => {
    setShowSignUpModal(false);

    if (success) {
      setAudienceData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          attendeeIDs: [...prev.eventDetails.attendeeIDs, userData?.userID],
        },
      }));
      setShowSuccessModal(true);
    }
  };

  const closeBuyTicketModal = (success?: boolean) => {
    setShowBuyTicketModal(false);

    if (success) {
      setAudienceData((prev: any) => ({
        ...prev,
        eventDetails: {
          ...prev.eventDetails,
          attendeeIDs: [
            ...(prev.eventDetails?.attendeeIDs || []),
            userData?.userID,
          ],
        },
      }));

      setShowPurchaseSuccessModal(true);
    }
  };

  const closePurchaseSuccessModal = () => {
    setShowPurchaseSuccessModal(false);
    setShowBuyTicketModal(false);
  };

  const sendGift = (giftContent: any, receiverId: string) => {
    if (loginData && currentEventId) {
      sendEventMessage(
        loginData.username,
        currentEventId,
        giftContent,
        loginData.accessToken,
        receiverId,
        "gift"
      );

      // Send a system message to chat when gift is sent
      const senderName = userData?.userID || loginData.username;
      let giftMessage = "";

      if (receiverId && receiverId !== "both") {
        // Find receiver name from participant details
        const participants = audienceData?.participantDetails || [];
        const receiver = participants.find((p: any) => p.userID === receiverId);
        const receiverName = receiver?.userID || receiverId;
        giftMessage = `${senderName} sent a gift to ${receiverName} 🎁`;
      } else {
        giftMessage = `${senderName} sent a gift 🎁`;
      }

      // Create the gift comment object
      const giftComment = {
        userId: senderName,
        eventId: currentEventId,
        commentData: giftMessage,
        commentType: "Audience",
        timestamp: Date.now(),
        profilePicture: userData?.profilePicture || "",
        commentId: `${senderName}-${Date.now()}-gift`,
      };

      // Add to local state immediately so user sees it right away
      setAudienceData((prev: any) => ({
        ...prev,
        chats: [...prev.chats, giftComment],
      }));

      // Send the gift message as a comment via WebSocket
      sendComment(senderName, currentEventId, giftMessage, "Audience");
    } else {
      console.error(
        "Cannot send gift: Not connected to an event or missing access token."
      );
    }
  };

  const sendComment = (
    userId: string,
    eventId: string,
    commentContent: any,
    commentType: string
  ) => {
    if (loginData && eventId) {
      sendEventMessage(
        userId,
        eventId,
        commentContent,
        loginData.accessToken,
        "",
        "comment",
        commentType
      );
    } else {
      console.error(
        "Cannot send comment: Not connected to an event or missing access token."
      );
    }
  };

  const sendLike = () => {
    if (loginData && currentEventId) {
      setAlreadyLiked(true);
      sendEventMessage(
        loginData.username,
        currentEventId,
        null,
        loginData.accessToken,
        "",
        "like"
      );

      const senderName = userData?.userID || loginData.username;
      const likeMessage = `${senderName} liked the stream ❤️`;

      // Create the like comment object
      const likeComment = {
        userId: senderName,
        eventId: currentEventId,
        commentData: likeMessage,
        commentType: "Audience",
        timestamp: Date.now(),
        profilePicture: userData?.profilePicture || "",
        commentId: `${senderName}-${Date.now()}-like`,
      };

      // Add to local state immediately so user sees it right away
      setAudienceData((prev: any) => ({
        ...prev,
        chats: [...prev.chats, likeComment],
      }));
      sendComment(senderName, currentEventId, likeMessage, "Audience");
    } else {
      console.error(
        "Cannot send like: Not connected to an event or missing access token."
      );
    }
  };

  useEffect(() => {
    return () => {
      disconnectWebSocket();
    };
  }, []);

  useEffect(() => {
    const unsubscribeBlur = navigation.addListener("blur", () => {
      setShowSignUpModal(false);
    });
    const unsubscribeState = navigation.addListener("state", () => {
      setShowSignUpModal(false);
    });
    return () => {
      unsubscribeBlur();
      unsubscribeState();
    };
  }, [navigation]);

  // Poll for live viewers every 10 seconds when event is live
  useEffect(() => {
    // Only poll when event is live and we have required data
    const isEventLive =
      eventStatus === EVENT_STATUS.LIVE || eventStatus === "ongoing";
    if (!isEventLive || !currentEventId || !loginData?.accessToken) {
      return;
    }

    const pollLiveViewers = async () => {
      try {
        console.log("=== POLLING: fetchLiveViewers called ===");
        const response = await fetchLiveViewers(
          currentEventId,
          loginData.accessToken
        );
        console.log("POLLING response:", response);

        // Response comes directly, not wrapped in statusCode/body
        const allViewers = response?.viewerDetails || [];
        console.log("POLLING allViewers:", allViewers);

        // Filter to only show audience members (exclude organizer and challenger)
        const filteredViewers = allViewers.filter(
          (viewer: any) => viewer.role === "audience"
        );

        console.log("POLLING filteredViewers:", filteredViewers);
        console.log("POLLING setting totalViewers to:", filteredViewers.length);

        // Use filtered count for actual audience count
        setTotalViewers(filteredViewers.length);
        setViewerDetails(filteredViewers);
      } catch (error) {
        console.error("Error polling live viewers:", error);
      }
    };

    // Initial fetch
    pollLiveViewers();

    // Set up polling interval (15 seconds)
    const intervalId = setInterval(pollLiveViewers, 15000);

    // Cleanup on unmount or when dependencies change
    return () => {
      clearInterval(intervalId);
    };
  }, [eventStatus, currentEventId, loginData?.accessToken]);

  return (
    <LiveStreamContext.Provider
      value={{
        gifts,
        comments,
        organizerData,
        audienceData,
        totalViewers,
        setUserData,
        userData,
        currentEventId,
        loginData,
        viewerDetails,
        liveStreamId,
        totalGiftedTokens,
        connectToEvent,
        alreadyLiked,
        disconnectFromEvent,
        closePurchaseSuccessModal,
        closeBuyTicketModal,
        sendGift,
        sendComment,
        setAudienceData,
        setOrganizerData,
        setTotalGiftedTokens,
        setEventDate,
        eventDate,
        sendLike,
        setLiveStreamId,
        updateEventTime,
        organiserLiveStart,
        organiserStreamCompleted,
        challengerLiveStart,
        challengerStreamCompleted,
        organiserStreamStatus,
        challengerStreamStatus,
        setOrganiserStreamStatus,
        setChallengerStreamStatus,
        setOrganiserLiveStart,
        setChallengerLiveStart,
        setOrganiserStreamCompleted,
        setChallengerStreamCompleted,
        loader,
        setLoader,
        isTwitchStreamingEnabled,
        setIsTwitchStreamingEnabled,
        eventStartTime,
        streamStatus,
        eventStatus,
        userRole,
        eventEndTime,
        setEventEndTime,
        setOrganiserStreamStartTime,
        setChallengerStreamStartTime,
        organiserStreamStartTime,
        challengerStreamStartTime,
        setEventStatus,
        organiserStreamPaused,
        challengerStreamPaused,
        setOrganiserStreamPaused,
        setChallengerStreamPaused,
      }}
    >
      {children}
      {showSignUpModal && (
        <>
          <LiveStreamSignUpModal
            closeSignUp={closeSignUpModal}
            accessToken={loginData?.accessToken}
            userId={userData?.userID}
            item={audienceData}
          />
        </>
      )}

      {showSuccessModal && (
        <>
          <SuccessFullSignUpModal
            item={audienceData.eventDetails}
            openSuccessSignUpModal={showSuccessModal}
            closeSuccessSignUpModal={() => {
              closeSuccessModal();
            }}
            closeSignUpModal={() => {
              closeSuccessModal();
            }}
            screenName={"liveScreen"}
          />
        </>
      )}

      {showBuyTicketModal && <LiveStreamBuyTicketModal />}
      {showPurchaseSuccessModal && (
        <PurchaseSuccessModal
          closeButTicket={() => {
            closeBuyTicketModal;
          }}
          item={audienceData.eventDetails}
          //@ts-ignore
          token={audienceData.eventDetails.ticketPrice}
          openPurchaseSuccess={() => {
            showPurchaseSuccessModal;
          }}
          closePurchaseSuccess={() => {
            closePurchaseSuccessModal();
          }}
        />
      )}
    </LiveStreamContext.Provider>
  );
};

export const useLiveStream = () => {
  const context = useContext(LiveStreamContext);
  if (!context) {
    throw new Error("useLiveStream must be used within a LiveStreamProvider");
  }
  return context;
};
